import { createApp } from 'vue'
import App from './App.vue'
import { installColorTheme } from './composables/useColorTheme'
import { installCdnFallback } from './utils/media'
import './styles/main.css'

installColorTheme()
installCdnFallback()
createApp(App).mount('#app')
